import { RootState } from '../../model/model'

export const afaCartOutOfAssortmentIsOpenSelector = (state: RootState) =>
  state.afaCartOutOfAssortment.isOpen
